import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ProtectedRoute from './components/components/route_protection/protectedRoute.jsx';
import Login from './components/login/login.jsx';
import NotFound from './tables/notFound.jsx';
import Dashboard from './tables/dashboard/Dashboard.jsx';
import Events from './tables/events/events.jsx';
import Organizers from './tables/organizers/Organizers.jsx';
import Profiles from './tables/profiles/Profiles.jsx';
import Promo from './tables/promo/promo.jsx';
import Stats from './tables/stats2/stats.jsx';
import PaymentTest from './tables/payment/paymentTest.jsx';

function App() {
  return (
    <Router>
      <Routes>
        {/* Dashboard - Start page */}
        <Route
          path="/"
          element={<ProtectedRoute Component={Dashboard} LoginComponent={Login} />}
        />
        
        {/* Events management */}
        <Route
          path="/events"
          element={<ProtectedRoute Component={Events} LoginComponent={Login} />}
        />
        
        {/* Organizers management */}
        <Route
          path="/organizers"
          element={<ProtectedRoute Component={Organizers} LoginComponent={Login} />}
        />
        
        {/* Users management - placeholder for now */}
        <Route
          path="/users"
          element={<ProtectedRoute Component={Profiles} LoginComponent={Login} />}
        />
        
        {/* Event promotion */}
        <Route
          path="/promo"
          element={<ProtectedRoute Component={Promo} LoginComponent={Login} />}
        />
        
        {/* Statistics */}
        <Route
          path="/statistics"
          element={<ProtectedRoute Component={Stats} LoginComponent={Login} />}
        />
        
        {/* Data changes - placeholder for now */}
        <Route
          path="/data-changes"
          element={<ProtectedRoute Component={NotFound} LoginComponent={Login} />}
        />
        
        {/* Reports */}
        <Route
          path="/reports"
          element={<ProtectedRoute Component={Profiles} LoginComponent={Login} />}
        />
        
        {/* Payment test */}
        <Route
            path="/paymenttest"
            element={<ProtectedRoute Component={PaymentTest} LoginComponent={Login} />}
        />

        {/* 404 - Not Found */}
          <Route
              path="*"
              element={<ProtectedRoute Component={NotFound} LoginComponent={Login} />}
          />
      </Routes>
    </Router>
  );
}

export default App;
